import { MenuPrintRuleService } from '@packages/charka-common-ui/graphql/types/graphql';

const menuPrintRuleServices = [MenuPrintRuleService.DigitalMenu, MenuPrintRuleService.OnlineOrder];
export default function convertStringToRuleService(service: string) {
  return menuPrintRuleServices.find((item) => {
    return item.toString().toLowerCase().split('_').join('').includes(service.toLowerCase());
  });
}
